import { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import { migrateLocalData, loginWithGoogle, logout } from "../services/apiService";
import { trackLogin } from "../services/analytics";

export function useAuth() {
  const [session, setSession] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [authError, setAuthError] = useState("");
  const [authSubmitting, setAuthSubmitting] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session: s } }) => {
      setSession(s);
      setAuthLoading(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange(async (_event, s) => {
      setSession(prev => {
        if (prev?.access_token === s?.access_token) return prev;
        return s;
      });
      if (s) setShowLogin(false);
      if (_event === "SIGNED_IN" && s) {
        trackLogin();
        await migrateLocalData();
      }
    });
    return () => subscription.unsubscribe();
  }, []);

  const handleGoogleLogin = async () => {
    setAuthError("");
    setAuthSubmitting(true);
    const { error } = await loginWithGoogle();
    if (error) { setAuthError(error.message); setAuthSubmitting(false); }
  };

  const handleLogout = async () => {
    await logout();
    setSession(null);
  };

  return {
    session, authLoading, authError, authSubmitting,
    showLogin, setShowLogin,
    handleGoogleLogin, handleLogout,
  };
}
